import { __rest } from "tslib";
const getSortFieldValue = (sort) => {
    const { field, orderType } = sort;
    return `${field}-${orderType}`;
};
export const parseDynamicNavigation = (_a) => {
    var { sort } = _a, model = __rest(_a, ["sort"]);
    return (Object.assign(Object.assign({}, model), { sort: sort ? getSortFieldValue(sort) : undefined }));
};
export default parseDynamicNavigation;
